import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

// components
import { Checkbox, Radio } from '@tcc/crate';

const baseString = 'vra-checkbox-radio';
const CheckboxRadio = ({
  className,
  dataTestId,
  disabled,
  isChecked,
  labelText,
  name,
  onChange,
  type='checkbox'
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  const Input = type === 'checkbox' ? Checkbox : Radio;
  return (
    <section className={classString}>
      <Input
        checked={isChecked}
        disabled={disabled}
        label={labelText}
        name={name}
        onChange={onChange}
        testId={dataTestId}
      />
    </section>
  );
};

CheckboxRadio.propTypes = {
  className: propTypes.string,
  dataTestId: propTypes.string,
  disabled: propTypes.bool,
  isChecked: propTypes.bool,
  labelText: propTypes.string.isRequired,
  name: propTypes.string,
  onChange: propTypes.func.isRequired,
  type: propTypes.oneOf(['checkbox', 'radio'])
};
export default CheckboxRadio;
